export default __webpack_public_path__ + "static/media/slide2.47a79be5.png";